var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("UNDER CONSTRUCTION")]),_vm._v(" Land for sale price prediction ")]),_c('div',[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"}})])],2)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }